import { getField } from 'vuex-map-fields';

export default {
  loadingContacts: state => state.loadingContacts,
  loadingOrganisationContacts: state => state.loadingOrganisationContacts,
  loadingSubscribers: state => state.loadingSubscribers,
  loadingContact: state => state.loadingContact,
  loadingConversationContacts: state => state.loadingConversationContacts,
  contactList: state => state.contactList,
  organisationContactList: state => state.organisationContactList,
  subscriberList: state => state.subscriberList,
  conversationContactList: state => state.conversationContactList,
  contact: state => state.contact,
  contactUpdated: state => state.contactUpdated,
  contactDeleted: state => state.contactDeleted,

  loadingActivities: state => state.loadingActivities,
  activityList: state => state.activityList,

  subscribersLoaded: state => state.subscribersLoaded,
  loadingContactTags: state => state.loadingContactTags,
  contactTagList: state => state.contactTagList,
  contactTagCreated: state => state.contactTagCreated,
  contactTagUpdated: state => state.contactTagUpdated,
  contactTagDeleted: state => state.contactTagDeleted,
  contactTagsSynced: state => state.contactTagsSynced,

  // paged organisation contacts list
  organisationContactPageLoading: state => state.organisationContactPage.loading,
  organisationContactPageList: state => state.organisationContactPage.list,

  loadingCustomFields: state => state.loadingCustomFields,
  customFieldList: state => state.customFieldList,
  customFieldSaved: state => state.customFieldSaved,
  customFieldDeleted: state => state.customFieldDeleted,
  customFieldsSynced: state => state.customFieldsSynced,
  customFieldChange: state => state.customFieldChange,

  contactNotesSynced: state => state.contactNotesSynced,
  apiError: state => state.apiError,
  importId: state => state.importId,
  calculatingUniqueContacts: state => state.calculatingUniqueContacts,
  uniqueContactsCount: state => state.uniqueContactsCount,
  exportId: state => state.exportId,
  exportError: state => state.exportError,
  contactCache: state => state.contactCache,

  importError: state => state.importError,
  getField,
};
